'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import EpInfoCard from '../../../../components/EpInfoCard';
import { EpSwitch, EpErrorMessage } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import styles from '@/components/HookFormComponents/components/EpSwitch/EpSwitch.module.scss';
import { useState } from 'react';

export default function NoIdToggle({
  isActive = false,
  translations,
}: {
  isActive?: boolean;
  translations: unknown;
}) {
  const { resetField, setValue, unregister, getValues } = useFormContext();

  const Person = useWatch({ name: 'person' });
  const personType = useWatch({ name: 'personType' });
  const checkIfIsPersonType = personType?.inputValue === '1';

  const notificationRefersToId = useWatch({
    name: 'notificationRefersToId.inputValue',
  });

  const isVisible = Person?.inputValue === 'true' && checkIfIsPersonType;

  function handleChange() {
    setValue('formUtils.stepNeedReview', '2');
    unregister('patientIdentification');
    unregister('patientName');
    unregister('genderId.inputValue');
    unregister('genderId.inputLabel');
    unregister('patientIdentification.inputValue');
    unregister('patientBirthDate');
    unregister('hospitalCare');
  }

  if (!isActive && !isVisible) return null;

  return (
    <>
      <EpInfoCard
        title={t(translations, `Don't have the patient identification number?`)}
      >
        <EpSwitch
          onChange={handleChange}
          disabled={!!notificationRefersToId}
          switchName="noId"
          switchLabel={t(
            translations,
            `Check this field if you do not have access to the patient identification number or the patient is not in an inpatient unit.`,
          )}
          className={styles['ep-switch--with-margin']}
        />
      </EpInfoCard>
      <EpErrorMessage inputName="noId" />
    </>
  );
}
